export default "/images/vendor/flag-icon-css/flags/1x1/gf.svg?74219f32e778ea33b181c400c6559a6c";